import React, { Component } from 'react';


const website = "https://namesbymeaning.com/"
const About = "Jude is one of the popular Names this year amoung boys"

class Favourites extends Component{
    constructor(){
        super()
        this.state = { year: new Date().toLocaleDateString()}
    }
    render(){
        const { flexStyle, shareStyle, headStyle, pStyle, pmixedStyle, awesomeStyle } = styles;
        return(
            <div style={flexStyle}>
            <a target="_blank" href={ 
                "https://twitter.com/home/?status=" 
                + About + "." 
                + " "
                 + "- " 
                 + website }>
            <i className="fa fa-share-alt" aria-hidden="true"  style={shareStyle}></i></a>
            <p style={headStyle}>Popular Boy Names </p>
            <p style={pStyle}>Jude is one of the popular Names this year amoung boys. </p>
            <p style={pmixedStyle}>{this.state.year} <i className="fas fa-eye" style={awesomeStyle}> </i> <span> 456k <i className="fas fa-check-circle" style={awesomeStyle}></i> 4.5k </span></p>
            </div>
        )
    }
};

const styles = {
    flexStyle:{
        width: "21%",
        backgroundColor: "white",
        borderRadius: "5px",
        WebkitFilter: "drop-shadow(0px 0px 2px #777)",
        marginRight: "auto",

    },
    shareStyle:{
        fontSize: "15px",
        color: "#4890c0",
        float: "right",
        padding: "20px",
        marginRight: "10px"
    },
    headStyle:{
        marginTop: "5px",
        marginLeft: "15px",
        fontWeight: "bold",
        color: "#4890c0"
    },
    pStyle:{
        marginLeft: "15px",
        fontSize: "12px"
    },
    pmixedStyle:{
        color:"grey",
        marginLeft: "15px",
        fontSize: "11px",
        marginBottom: "2px",
        fontWeight: "400"
    },
    awesomeStyle: {
        color: "#4890c0",
        marginLeft: "10px",
    }
}
export default Favourites;


// WEBPACK FOOTER //
// ./src/components/favorites/favourites.js